document.addEventListener('DOMContentLoaded', function () {
    const phoneIcon = document.getElementById('phone-icon');
    const phonePopup = document.getElementById('phone-popup');
    const closeButton = phonePopup.querySelector('.close-button');
    const phoneNumber = phoneIcon.dataset.phone;

    // Function to detect if the user is on a smartphone
    function isSmartphone() {
        return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    // Click event for the phone icon
    phoneIcon.addEventListener('click', function (event) {
        event.preventDefault();

        if (isSmartphone()) {
            // Redirect to call on smartphones
            window.location.href = `tel:${phoneNumber}`;
        } else {
            // Toggle popup on non-smartphones
            phonePopup.classList.toggle('hidden');
        }
    });

    // Click event for the close button
    closeButton.addEventListener('click', function () {
        phonePopup.classList.add('hidden');
    });
});
